export default class Partners {
    constructor() {
      this.classNames = {
        block: 'b-af-partners',
        slider: 'b-af-partners__main-slider',
        prevArrow: 'b-af-partners__main-nav-prev',
        nextArrow: 'b-af-partners__main-nav-next',
        tabs: 'b-af-partners__main-tab',
        collections: 'b-af-partners__main-logo-collection',
        popupTrigger: 'b-af-partners__main-logo-popup-trigger',
        popupText: 'b-af-partners__main-logo-popup',
        popupBodyClassActive: 'b-af-partners__main-logo-popup--active',
      }

      this.blocks = this.getPartnerBlocks();

      if (this.blocks.length > 0) {
        this.init(this.blocks);
      }
    }

    init(blocks) {
      blocks.forEach(block => {
        const slider = block.querySelector(`.${this.classNames.slider}`);
        const collection = block.querySelector(`.${this.classNames.collections}`);
        const tab = block.querySelectorAll(`.${this.classNames.tabs}`);
        const popupTrigger = block.querySelectorAll(`.${this.classNames.popupTrigger}`);

        if (window.innerWidth > 768) {
            this.handleSlider(slider, block, collection);
            this.handleHoverOnPopupTrigger(popupTrigger, block);
        }

        this.handleTabs(tab, block);
        this.handleModal();

      });
    }

    handleModal() {
        // Append empty modal to body
        const popupText = document.createElement('div');
        popupText.classList.add(this.classNames.popupText);
        document.body.appendChild(popupText);
    }

    handleHoverOnPopupTrigger(popupTrigger) {
        var that = this;

        popupTrigger.forEach(trigger => {
            trigger.addEventListener('mouseenter', () => {
                if(!document.body.classList.contains('hovering')) {
                    document.body.classList.add('hovering');
                    that.handlePopupTriggerHover(trigger);
                }
            });

            trigger.addEventListener('mouseleave', () => {
                if(document.body.classList.contains('hovering')) {
                    document.body.classList.remove('hovering');
                    const popupText = document.querySelector(`.${this.classNames.popupText}`);
                    if (popupText) {
                        popupText.style.display = 'none';
                        document.body.classList.remove(this.classNames.popupBodyClassActive);
                    }
                }
            });
        });
    }

    handlePopupTriggerHover(trigger) {
        const popupText = document.querySelector(`.${this.classNames.popupText}`);
        const theText = trigger.dataset.text;

        if (popupText && !document.body.classList.contains(this.classNames.popupBodyClassActive)) {
            document.body.classList.add(this.classNames.popupBodyClassActive);
            popupText.innerHTML = theText;
            popupText.style.display = 'block';


            const triggerRect = trigger.getBoundingClientRect();
            const popupRect = popupText.getBoundingClientRect();

            const top = triggerRect.top + window.scrollY - popupRect.height - 10;
            const left = triggerRect.left + window.scrollX + (triggerRect.width / 2);

            popupText.style.top = `${top}px`;
            popupText.style.left = `${left}px`;
        }
    }


    handleTabs(tab, block) {
        tab.forEach(tab => {
            tab.addEventListener('click', (e) => {
                e.preventDefault();
                this.handleTabClick(tab, block);
            });
        });
    }

    handleTabClick(tab, block) {
        const tab_id = tab.dataset.tab;

        // if tab active, do nothing
        if (tab.classList.contains('active')) {
            return;
        }

        this.hideAllCollections(block);
        this.showCollection(tab_id, block);
    }

    hideAllCollections(block) {
        const activeCollection = block.querySelector(`.${this.classNames.collections}.active`);
        const activeTab = block.querySelector(`.${this.classNames.tabs}.active`);

        if (activeCollection) {
            activeCollection.classList.remove('active');
            const slider = activeCollection.querySelector(`.${this.classNames.slider}`);

            if (slider && $(slider).hasClass('slick-initialized') && window.innerWidth > 768) {
                $(slider).slick('unslick');
            }
        }

        if (activeTab) {
            activeTab.classList.remove('active');
        }
    }

    showCollection(tab_id, block) {
        const collection = block.querySelector(`.${this.classNames.collections}[data-tab="${tab_id}"]`);
        const tab = block.querySelector(`.${this.classNames.tabs}[data-tab="${tab_id}"]`);

        if (collection) {
            collection.classList.add('active');
            const slider = collection.querySelector(`.${this.classNames.slider}`);
            const totalSlides = slider.dataset.slides;

            if(totalSlides > 5 && window.innerWidth > 768) {
                this.handleSlider(slider, block, collection);
            }
        }

        if (tab) {
            tab.classList.add('active');
        }
    }

    handleSlider(slider, block, collection) {
      if (!slider) {
        return;
      }

      let prevArrow = collection.querySelector(`.${this.classNames.prevArrow}`);
      let nextArrow = collection.querySelector(`.${this.classNames.nextArrow}`);

      $(slider).slick({
        autoplay: false,
        center: false,
        pauseOnHover: false,
        loop: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
      });

      // Add the triiger to all items even cloned items
      const popupTrigger = block.querySelectorAll(`.${this.classNames.popupTrigger}`);
      this.handleHoverOnPopupTrigger(popupTrigger, block);
    }

    getPartnerBlocks() {
        return Array.from(document.querySelectorAll(`.${this.classNames.block}`));
    }
}



// WEBPACK FOOTER //
// ./scripts/blocks/partners.js